import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const LINK_GROUPS = [
  {
    heading: 'Plant Capacities',
    links: [
      { to: '/24-bpm-water-plant', label: '24 BPM Water Plant' },
      { to: '/30-bpm-water-plant', label: '30 BPM Water Plant' },
      { to: '/40-bpm-water-plant', label: '40 BPM Water Plant' },
      { to: '/60-bpm-water-plant', label: '60 BPM Water Plant' },
      { to: '/90-bpm-water-plant', label: '90 BPM Water Plant' },
      { to: '/120-bpm-water-plant', label: '120 BPM Water Plant' },
      { to: '/200-bpm-water-plant', label: '200 BPM Water Plant' }
    ]
  },
  {
    heading: 'Machinery',
    links: [
      { to: '/solutions/water-treatment', label: 'Water Treatment (RO, WTP, STP, ETP, ZLD)' },
      { to: '/solutions/bottling-machinery', label: 'Bottling & Filling Machinery' },
      { to: '/solutions/packaging-machinery', label: 'Packaging Machinery' },
      { to: '/solutions/beverage-plants', label: 'Beverage Plants (Water, Juice, CSD)' },
      { to: '/solutions/bottle-manufacturing', label: 'PET Bottle Manufacturing' },
      { to: '/products/60-bpm-water-filling-machine', label: '60 BPM Filling Machine' },
      { to: '/products/pet-bottle-blowing-machine', label: 'PET Bottle Blowing Machine' }
    ]
  },
  {
    heading: 'Resources',
    links: [
      { to: '/blog', label: 'Knowledge Hub — All Guides' },
      { to: '/blog/mineral-water-plant-cost-india', label: 'Mineral Water Plant Cost Guide' },
      { to: '/blog/licences-required-mineral-water-bottling-plant', label: 'Licenses Required for Water Plants' },
      { to: '/how-to-start-mineral-water-business', label: 'How to Start a Water Business' },
      { to: '/projects', label: 'Recent Project Case Studies' },
      { to: '/installation-gallery', label: 'Installation Gallery' },
      { to: '/contact', label: 'Request Project Quotation' }
    ]
  }
];

export const InternalLinks = ({ currentPath = '' }) => (
  <section className="py-14 bg-gray-50 border-t border-gray-200" data-testid="internal-links-section">
    <div className="container mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
        Explore More from Alden Technologies
      </h2>
      <div className="grid md:grid-cols-3 gap-10">
        {LINK_GROUPS.map((group) => (
          <div key={group.heading}>
            <h3 className="text-sm font-bold uppercase tracking-wider text-alden-green mb-4">{group.heading}</h3>
            <ul className="space-y-2">
              {group.links
                .filter((l) => l.to !== currentPath)
                .map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="inline-flex items-center gap-2 text-gray-700 hover:text-alden-green transition-colors text-sm font-medium"
                    >
                      <ArrowRight className="w-3.5 h-3.5 text-alden-green flex-shrink-0" />
                      {l.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default InternalLinks;
